"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get MeetingTranscriptIngestModel () {
        return MeetingTranscriptIngestModel;
    },
    get VideoConferenceServiceOptionalSchema () {
        return VideoConferenceServiceOptionalSchema;
    },
    get VideoConferenceServiceSchema () {
        return VideoConferenceServiceSchema;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const MeetingTranscriptIngestModel = _zod.z.object({
    status: _models.MeetingTranscriptIngestStatusSchema,
    errorCode: _zod.z.string().optional()
});
const VideoConferenceServiceBase = _zod.z.object({
    joinUrl: _zod.z.string(),
    meetingId: _zod.z.string(),
    transcriptIngest: MeetingTranscriptIngestModel.optional()
});
/** camelCase mirror of `ZoomMeetingSettings` — the effective Zoom settings that gate transcripts. */ const ZoomMeetingSettingsServiceSchema = _zod.z.object({
    usePmi: _zod.z.boolean(),
    autoRecording: _zod.z.enum([
        "local",
        "cloud",
        "none"
    ]).catch("none"),
    audioTranscript: _zod.z.boolean().optional()
});
/** camelCase mirror of `TeamsMeetingSettings` — the effective recording setting echoed by Graph. */ const TeamsMeetingSettingsServiceSchema = _zod.z.object({
    recordAutomatically: _zod.z.boolean()
});
const VideoConferenceServiceSchema = _zod.z.discriminatedUnion("provider", [
    VideoConferenceServiceBase.extend({
        provider: _zod.z.literal("zoom"),
        hostId: _zod.z.string(),
        password: _zod.z.string().optional(),
        settings: ZoomMeetingSettingsServiceSchema
    }),
    VideoConferenceServiceBase.extend({
        provider: _zod.z.literal("teams"),
        settings: TeamsMeetingSettingsServiceSchema
    })
]);
const VideoConferenceServiceOptionalSchema = VideoConferenceServiceSchema.optional();
